import { signal } from 'services/SignalsService'

import TimeStage from './TimeStage'

export default class StopStage extends TimeStage {
  constructor(data, id){
    super(data, id)
  }

  completeCalculation(time){
    super.completeCalculation(time)
    signal.dispatch('BEGIN-STOP-REEL', this.reelID)
  }
}
